import { SET_SLIDEOUT_DATA, SET_ACTIVE_SLIDER } from "../../actions/setSlideoutDataAction";
const initialState = {
    activeSlider: null,
    dueTasks: {
        todaysTodos: 0,
        tomorrowsTodos: 0,
        thisWeeksTodos: 0,
        nextWeeksTodos: 0,
        tasksWithNoDueDate: 0,
        projectsWithNoDueDate: 0,
        overdueTodos: 0
    }
};
const SlideoutDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SLIDEOUT_DATA:
            return {
                ...state,
                activeSlider: action.payload.activeSlider,
                dueTasks: action.payload.dueTasks
            };
        case SET_ACTIVE_SLIDER:
            return {
                ...state,
                activeSlider: action.payload.activeSlider
            };
        default:
            return state;
    }
};

export default SlideoutDataReducer;